import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface OperatorSelfDepositState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorSelfDepositState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorSelfDepositSelects = {
  loading: (state: RootState) => state.operatorSelfDeposit.loading,
  dateRange: (state: RootState) => state.operatorSelfDeposit.dateRange,
  queryParams: (state: RootState) => state.operatorSelfDeposit.queryParams,
  transfers: (state: RootState) => state.operatorSelfDeposit.transfers,
};

export const operatorSelfDepositThunks = {
  list: createAsyncThunk(
    "operatorSelfDeposit/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.OperatorDeposit,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorSelfDepositSlice = createSlice({
  name: "operatorSelfDeposit",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorSelfDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorSelfDepositThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorSelfDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorSelfDepositActions = operatorSelfDepositSlice.actions;
